export default __webpack_public_path__ + "static/chatgpt-b1c8459b8232b245bd70e4023c37f8f5.png";